import * as React from 'react'
import styled from 'styled-components'

import ShippingSelectorModal from '~/components/shipping-modal'
import { useMultiDistributorSession } from '~/hooks'
import useModalManager from '~/hooks/use-modal-manager'
import Anchor from '~/truck/anchor'
import Label from '~/truck/label'

import { CTABasicContent } from '../cta'

const LinkContainer = styled.div`
  display: flex;
  margin-top: ${props => props.theme.spacing.comfortable}px;

  > strong {
    margin-left: ${props => props.theme.spacing.cozy}px;
    margin-right: ${props => props.theme.spacing.cozy}px;
  }
`

const StyledText = styled(Label)`
  margin-top: ${props => props.theme.spacing.relaxed}px;
`

export function NotAvailable(props) {
  const { activeVariant } = props

  const modalManager = useModalManager()

  const { multiDistributorSession } = useMultiDistributorSession()

  return (
    <CTABasicContent name={activeVariant.name} presentation={activeVariant.presentation}>
      <StyledText as="p" $textStyle="h3Semibold">
        {multiDistributorSession
          ? 'No disponible en la dirección seleccionada'
          : 'Selecciona una dirección para ver disponibilidad'}
      </StyledText>
      <LinkContainer>
        <Anchor
          as="span"
          style={{ cursor: 'pointer' }}
          $textStyle="h5Semibold"
          onClick={() => {
            modalManager.openModal(ShippingSelectorModal)
          }}
        >
          {multiDistributorSession ? 'Cambiar dirección' : 'Seleccionar dirección'}
        </Anchor>
        <strong>·</strong>
        <Anchor href="/" $textStyle="h5Semibold">
          Volver al catálogo
        </Anchor>
      </LinkContainer>
    </CTABasicContent>
  )
}
